import styled from 'styled-components';
import { Grid, Button, TextField } from '@mui/material';

export const GridFilter = styled(Grid)`
    display: flex;
    flex-direction: row;
    align-items: end;
    height: 101px;
    background-color: #f0f1f3;
    border-radius: 12px;
`;

export const ContainerFilter = styled.div`
    display: flex;
    align-items: center;
    flex-direction: row;
    width: 100%;
    height: 100%;
    padding-left: 24px;
`;

export const FilterButton = styled(Button)`
    padding: 0px 16px;
    gap: 8px;
    width: 73px;
    height: 42px;
    background: #3a6647;
    text-transform: capitalize;
    box-shadow: 0px 3px 8px rgba(0, 0, 0, 0.08);
    border-radius: 8px;
`;

export const CleanButton = styled(Button)`
    background-color: transparent;
    color: #3a6647;
    text-decoration: underline !important;
    text-transform: capitalize;
    font-size: 16px;

    &:hover {
        background-color: transparent;
    }
`;

export const Div = styled.div`
    width: ${({ width }) => width ?? '6.5rem'};
    display: flex;
    align-items: center;
    gap: 1.25rem;

    justify-content: space-between;

    > p {
        font-size: 20px;
    }
`;

export const TextFildStyled = styled(TextField)`
    border-radius: 8px;
    width: 100%;
    background-color: white;
`;
